import { DefaultPrimaryHeader, DescriptionSecondary, HeaderBlock } from '../activityFeedHeaderShared';

function AssetGroupHeader({ entity, item, activity }) {
  return <HeaderBlock primary={<DefaultPrimaryHeader label={entity?.name} activity={activity} />} secondary={<DescriptionSecondary item={item} />} />;
}

export default AssetGroupHeader;
